module.exports = __webpack_public_path__ + "img/prueba_dinamica_petrol.b3f510da.svg";